import type { Drama } from "@/pages/home/types";

interface DramaCardProps {
  drama: Drama;
  rank?: number;
}

export default function DramaCard({ drama, rank }: DramaCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative w-full aspect-[5/7] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title} 剧集海报`}
          title={`${drama.title} 韩剧海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof rank === "number" && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-foreground-950/80 font-heading text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-0.5 font-label text-xs font-bold text-foreground-950">
          {drama.rating.toFixed(1)}分
        </span>
        <span className="absolute bottom-2 left-2 rounded-md bg-background-50/90 px-2 py-0.5 font-label text-xs font-medium text-foreground-800">
          {drama.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950">
          {drama.title}
        </h3>
        <p className="font-label text-xs text-foreground-500">
          {drama.year} · 共{drama.episodes}集 · {drama.platform}
        </p>
        <p className="line-clamp-2 font-body text-xs leading-relaxed text-foreground-700">
          {drama.summary}
        </p>
        <div className="mt-auto flex flex-wrap gap-1.5 pt-1">
          {drama.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 font-label text-[11px] text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}